import React from 'react';
import classnames from 'classnames';

import Time from '../../../common/Time';
import IconCell from '../components/IconCell';
import { CELL_WIDTH_LED, CELL_WIDTH_STATUS } from '../constants';
import { t } from '../../../../modules/infra/i18n';

const isActiveStatus = (sale) => {
  if (!sale.items) {
    return sale.status === 'Paid' && sale.refundable;
  }

  return sale.items.some(item => (item.status === 'Paid' && item.refundable));
};

export const status = {
  id: 'status',
  accessor: 'status',
  Header: '',
  className: 'o-flexbox o-flexbox--content-align-center o-flexbox--justify-center',
  Cell: props => (
    <div
      className={classnames('c-led', { 'is-active': isActiveStatus(props.original) })}
    />
  ),
  width: CELL_WIDTH_LED,
};

export const getTimeColumn = () => ({
  Header: t('register:summary.table.time_header'),
  headerClassName: 'u-text-left',
  accessor: 'time',
  id: 'time',
  className: 'u-pl0 o-flexbox o-flexbox--content-align-center',
  Cell: props => <Time>{props.value}</Time>,
  width: 100,
});

export const getCardInfoColumn = () => ({
  Header: t('register:summary.table.card_info_header'),
  headerClassName: 'u-text-left',
  accessor: 'cardInfo',
  id: 'cardInfo',
  className: 'o-flexbox o-flexbox--content-align-center',
  width: 180,
  Cell: ({ value }) => value.map((item, key) => <div key={key}>{item}</div>),
});

export const icon = {
  Header: '',
  accessor: 'icons',
  id: 'icons',
  className: 'u-pl0 o-flexbox o-flexbox--content-align-center o-flexbox--justify-center',
  Cell: IconCell,
  width: CELL_WIDTH_STATUS,
};

export const getDescriptionColumn = () => ({
  Header: t('register:summary.table.description_header'),
  headerClassName: 'u-text-left',
  accessor: 'description',
  id: 'items',
  className: 'o-flexbox o-flexbox--content-align-center u-pre-wrap',
  Cell: ({ value }) => (value || '').split('\n').join(', '),
});
